module.exports = __webpack_public_path__ + "static/media/health_vr.8036c2d7.jpg";